// eslint-disable-next-line ember/no-classic-components
import Component from '@ember/component';
// eslint-disable-next-line ember/no-computed-properties-in-native-classes
import { computed, action, set } from '@ember/object';
import { dropTask } from 'ember-concurrency';
import { RECEPTIONIST } from 'garaje/utils/roles';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

/**
 * Settings panel for modifying required pre-registration settings
 * @param {Class<Location>} location Required - A location model
 * @param {Class<TaskInstance>} saveTask Required - A saveLocation task instance
 */
export default class PreRegRequired extends Component {
  @service store;

  tagName = '';

  @tracked hasReceptionist = false;

  isOpen = false;

  // eslint-disable-next-line ember/classic-decorator-hooks
  init() {
    super.init(...arguments);
    this.loadFrontDeskAdmin.perform();
  }

  /**
   * @return {Boolean}
   */
  @computed('isOpen', 'location.preRegistrationRequiredEnabled')
  get isDisableButtonVisible() {
    return (
      this.isOpen &&
      this.location.preRegistrationRequiredEnabled &&
      !('preRegistrationRequiredEnabled' in this.location.changedAttributes())
    );
  }

  @action
  cancel() {
    if (this.location.hasDirtyAttributes) {
      this.location.rollbackAttributes();
    }
    set(this, 'isOpen', false);
  }

  /**
   * loadFrontDeskAdmin
   * Task used for loading receptionists from the server if they don't already exist in the store
   */
  @dropTask
  *loadFrontDeskAdmin() {
    const cachedReceptionists = this.store.peekAll('location-role').filter((role) => role.roleName === RECEPTIONIST);
    let receptionists = [];

    if (!cachedReceptionists.length) {
      receptionists = yield this.store.query('location-role', {
        filter: {
          location: this.location.id,
          roles: RECEPTIONIST,
        },
      });
    }

    if (cachedReceptionists.length || receptionists.length) {
      this.hasReceptionist = true;
    }
  }
}
